export default function (button) {
  $(button).click(function (e) {
    e.preventDefault();
    const loc = $(this).attr('href');
    window.open(
      loc,
      '_blank',
      `height=450,width=550,top=${$(window).height() / 2 - 225},left=${
        $(window).width() / 2
      }`
    );
  });
}
